import $ from 'jquery'
import Backbone from 'backbone'
import template from './confirm-prompt.hbs'
import BusyButton from './busy-button'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'

/**
 * Creates a confirmation prompt with a title, message, and yes and no buttons.
 *
 * Example Usage:
 *
 * <pre>
 * let prompt = new ConfirmPrompt({
 *     titleKey: 'admin.recalcScores',
 *     messageKey: 'admin.recalcScoresConfirm',
 *     onConfirm: function() {
 *         $.post('api/admin/recalc-scores')
 *     },
 *     detailed: true // optional
 * })
 * appDisplay.dialog(prompt)
 * prompt.once('done', () => console.log('user confirmed action'))
 * prompt.once('cancel', () => console.log('user cancelled action'))
 * </pre>
 */
var ConfirmPrompt = Backbone.View.extend({

	tagName: 'form',

	className: 'confirm-prompt dialog-message',

	events: {
		'submit': 'submit',
		'click .cancel': 'close'
	},

	/**
	 * @constructs
	 * @param {string} [options.titleKey] The i18n code for the title.  Can also
	 * be any text value (will be escaped)
	 * @param {string} [options.messageKey]
	 *
	 * @param {string} [options.message] An escaped html string used for the
	 * dialog content.
	 *
	 * @param {Function} [options.onConfirm] An optional callback that will
	 * be called after the form is submitted and before 'done' is triggered.
	 *
	 * @param {string} [options.confirmLabel='common.yes'] i18n code for primary button
	 * @param {string} [options.cancelLabel='common.no'] i18n code for cancel button
	 *
	 * @param {boolean} [options.confirmOnly=false]
	 * 	set to true if cancel should not be displayed
	 *
	 * @param {boolean} [options.detailed=false] true if title should be
	 * displayed as a header
	 *
	 */
	initialize: function(options = {}) {
		this.options = options
		this.options.confirmLabel = _.result(options, 'confirmLabel', 'common.yes')
		this.options.cancelLabel = _.result(options, 'cancelLabel', 'common.no')
	},

	render: function() {
		this.$el.empty().append(template(this.context()))

		if (this.options.detailed) {
			this.$el.addClass('detailed-confirm-prompt')
		}

		return this
	},

	context: function() {
		const {titleKey, messageKey, message, messageItems} = this.options
		return _.extend({
			title: i18n.get(titleKey),
			message: _.defaultTo(message, _.escape(i18n.get(messageKey))),
			messageItems,
			detailed: this.detailed
		}, this.options)
	},

	submit: function(e) {
		e && e.preventDefault()
		this.busyButton = new BusyButton({
			el: this.$('.submit')
		}).loading()
		var result = _.result(this.options, 'onConfirm')
		$.when(result).done(this.trigger.bind(this, 'done'))
	},

	// note: overriding close handles both clicking 'cancel' and pressing escape
	close: function() {
		this.trigger('cancel')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.busyButton], 'remove')
	}

})

export default ConfirmPrompt

ConfirmPrompt.__filename__ = 'components/confirm-prompt.js'
